import styled from 'styled-components';

export const CancelStatusPopMainWrap = styled.div(
    props => `
        width: 48rem;
        display: flex;
        flex-direction: column;
        border-radius: ${props.theme.misc.borderRadius.base};
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
        background-color: ${props.theme.colors.white.base};
    `
);

export const StatusHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-image: ${props.color === 'red' ? 'linear-gradient(74deg, #ffe380 -23%, #ffb480 25%, #ff8080 96%)' : 'linear-gradient(to left,#f09819,#f8c34e ,#ffe577)'};
        border-radius: ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base} 0 0;
    `
);

export const StatusTextWrap = styled.div(
    props => `
        width:60%;
        display: flex;
        padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.base} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l30};
    `
);

export const StatusText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font24};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        text-transform: ${props.theme.font.textTransform.capital};
    `
);

export const StatusImgWrap = styled.div(
    props => `
        display: flex;
        width: 40%;
        align-self: flex-end;
        justify-content: flex-end;
    `
);

export const StatusInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l30};
    `
);

export const StatusInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        padding-bottom: ${props.theme.spacing.large.l20};

        .boldText{
            font-weight: ${props.theme.font.fontWeight.bold};
        }
    `
);

export const StatusBtnWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: ${props.theme.spacing.large.l30};
    `
);

export const StatusBtn = styled.button(
    props => `
        display: flex;
        align-self: flex-end;
        outline: none;
        border: none;
        border-radius: 4rem;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l25};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
        cursor: pointer;
    `
)